/**
 * body要素にデバイス識別クラス名を追加
 */

'use strict';

var ua = require('./useragent');

function init() {
  document.addEventListener('DOMContentLoaded', function () {
    if (ua.ie11) {
      document.body.classList.add('ie11');
    }
    if (ua.sd) {
      document.body.classList.add('sd');
      if (ua.ipad) {
        document.body.classList.add('iPad');
      }
      if (ua.iphone) {
        document.body.classList.add('iPhone');
      }
      if (ua.android) {
        document.body.classList.add('android');
      }
      if (ua.androidTab) {
        document.body.classList.add('android', 'androidTab');
      }
    }
  });
}

module.exports = init;
